var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatAssistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 20V14.88C1.71333 14.0667 1.10667 13.1467 0.68 12.12C0.226667 11.04 0 9.91333 0 8.74C0 7.15333 0.4 5.68667 1.2 4.34C1.97333 3.02 3.02 1.97333 4.34 1.2C5.7 0.4 7.17333 0 8.76 0H11.26C12.8467 0 14.3133 0.4 15.66 1.2C16.98 1.97333 18.0267 3.02 18.8 4.34C19.6 5.68667 20 7.15333 20 8.74C20 10.3267 19.6 11.8 18.8 13.16C18.0267 14.48 16.98 15.5267 15.66 16.3C14.3133 17.1 12.8467 17.5 11.26 17.5H8.76C8.17333 17.5 7.53333 17.4333 6.84 17.3L2.5 20ZM3.76 17.74L6.6 15.96L7.1 16.06C7.64667 16.18 8.2 16.24 8.76 16.24H11.26C12.62 16.24 13.88 15.9 15.04 15.22C16.1733 14.5533 17.0733 13.66 17.74 12.54C18.42 11.3667 18.76 10.1 18.76 8.74C18.76 7.38 18.42 6.12 17.74 4.96C17.0733 3.82667 16.1733 2.92667 15.04 2.26C13.88 1.58 12.62 1.24 11.26 1.24H8.76C7.4 1.24 6.13333 1.58 4.96 2.26C3.84 2.92667 2.94667 3.82667 2.28 4.96C1.6 6.12 1.26 7.38 1.26 8.74C1.26 9.74 1.44 10.6933 1.8 11.6C2.17333 12.4933 2.70667 13.2933 3.4 14L3.76 14.36V17.74Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAssistant);
export default __webpack_public_path__ + "static/media/ChatAssistant.d389aae69319fd9cd154fa55f6282cd0.svg";
export { ForwardRef as ReactComponent };